// import { QRCodeCanvas } from "qrcode.react";
// import React from "react";
// import panfront from "../Assets/Logos/5.png";
// import panback from "../Assets/Logos/6.png";
// import ashok from "../../src/Assets/Logos/ashok1.png";
// import { FaCaretLeft } from "react-icons/fa6";

// const PanCardPdf = React.forwardRef(
//   ({ panData, uploadedImageUrl, uploadedSignatureUrl, qrText }, ref) => {
//     const formatDate = (dateString) => {
//       if (!dateString) return "N/A";
//       const [year, month, day] = dateString.split("-");
//       return `${day}/${month}/${year}`;
//     };
//     return (
//       <div
//         className="flex justify-center items-start mx-[19rem] min-h-screen bg-white py-8 gap-x-6"
//         ref={ref}
//       >
//         {/* Left side */}
//         <div className="w-[210mm] flex justify-center">
//           <div
//             className="w-[24.8rem] h-[15.8rem] rounded-xl p-3 relative box-border bg-cover bg-center"
//             style={{ backgroundImage: `url(${panfront})` }}
//           >
//             {/* PAN Details Row */}
//             <div className="flex gap-1 mt-12">
//               {/* Photo */}
//               <div className="w-[70px] h-[60px] border">
//                 <img
//                   src={uploadedImageUrl}
//                   alt="User"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               {/* PAN Info */}
//               <div className="flex-1 text-center">
//                 <p className="text-[10px] font-bold tracking-tight text-blue-900">
//                   स्थायी लेखा संख्या कार्ड
//                 </p>
//                 <p className="text-[10px] font-bold tracking-tight text-blue-900">
//                   Permanent Account Number Card
//                 </p>
//                 <p className=" text-sm font-bold tracking-widest text-black">
//                   {panData.pan_number}
//                 </p>
//               </div>

//               {/* QR Code */}
//               <div className="bg-white p-[0.17rem]">
//                 <QRCodeCanvas value={qrText} level="H" size={80} />
//               </div>
//             </div>

//             {/* <p className="float-end text-[0.6rem] mt-2">28072019</p> */}

//             {/* Footer Details */}
//             <div className="text-[9.5px] absolute left-3 right-3 bottom-3">
//               <p className="flex flex-col mb-1 ">
//                 <strong className="text-blue-900">नाम/ Name:</strong>
//                 <strong>{panData.full_name}</strong>
//               </p>

//               <p className="flex flex-col mt-1">
//                 <strong className="text-blue-900 ">
//                   पिता का नाम / Father's Name:
//                 </strong>
//                 <strong>{panData.father_name}</strong>
//               </p>

//               <div className="flex justify-between items-end mt-1">
//                 <p className="flex flex-col">
//                   <strong className="text-blue-900">
//                     जन्म की तारीख / <span className="flex">Date of Birth:</span>
//                   </strong>
//                   {/* updated date */}
//                   <strong>{formatDate(panData.dob)} </strong>
//                 </p>

//                 {/* Signature Box */}
//                 {/* Signature Box */}
//                 <div
//                   className="bg-white ml-10 py-2 px-3 rounded-sm flex items-center justify-center border border-gray-300"
//                   style={{
//                     width: "7rem",
//                     height: "3rem",
//                     minWidth: "7rem",
//                     minHeight: "3rem",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   {uploadedSignatureUrl ? (
//                     <img
//                       src={uploadedSignatureUrl}
//                       alt="Signature"
//                       className="object-contain"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "contain",
//                         padding: "2px",
//                       }}
//                     />
//                   ) : (
//                     <div
//                       style={{
//                         color: "#9CA3AF",
//                         fontSize: "12px",
//                         textAlign: "center",
//                         fontWeight: "500",
//                       }}
//                     >
//                       Signature
//                     </div>
//                   )}
//                 </div>

//                 <div className="flex flex-col mb-2 text-[4px] text-black">
//                   <div className="flex items-center">
//                     <FaCaretLeft className="text-black absolute mt-2 ml-[0.29rem] text-[5px]" />
//                     <p className="ml-3">
//                       PAN Application Digitally Signed Card Not
//                     </p>
//                   </div>
//                   <p className="ml-[0.8rem]">Valid unless Physically Signed</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Side */}
//         <div className="w-[210mm] flex justify-center">
//           <div
//             className="w-[24.8rem] h-[15.8rem] rounded-xl p-3 relative box-border bg-cover bg-center"
//             style={{ backgroundImage: `url(${panback})` }}
//           >
//             {/* Back Side Content */}
//             <div className="text-[8.5px] text-black leading-snug">
//               {/* Hindi instruction */}
//               <div className="mt-2">
//                 <p className="font-semibold">
//                   इस कार्ड के खोने / पाने पर कृपया सूचित करें / लौटायें :
//                 </p>
//                 <p className="mt-1">
//                   आयकर पैन सेवा इकाई, प्रोटिअन ईगॉव टेक्नोलॉजीज लिमिटेड <br />
//                   पहली मंजिल, टाइम्स टॉवर, कमला मिल्स कंपाउंड, <br />
//                   सेनापति बापट मार्ग, लोअर परेल, <br />
//                   मुंबई ४०० ०१३
//                 </p>
//               </div>

//               {/* English instruction */}
//               <div className="mt-12">
//                 <p className="mt-3 font-semibold">
//                   If this card is lost / someone's lost card is found, <br />
//                   please inform / return to :
//                 </p>
//                 <p className="mt-1">
//                   Income Tax PAN Services Unit, Protean eGov Technologies
//                   Limited <br />1<sup>st</sup> Floor, Times Tower, Kamala Mills
//                   Compound, <br />
//                   Senapati Bapat Marg, Lower Parel, <br />
//                   Mumbai 400 013
//                 </p>

//                 {/* Contact Info */}
//                 <p className="">
//                   Tel: 91-20-2721 8080, e-mail: tininfo@proteanctech.in <br />
//                   ito.systems1@incometax.gov.in, pan@incometax.gov.in
//                 </p>
//               </div>
//             </div>

//             {/* Hologram box */}
//             {/* <div className="absolute top-11 right-3 border border-gray-300 bg-white/30 w-[4rem] h-[4rem] flex items-center justify-center">
//             <span className="text-[8px] font-semibold text-gray-500">
//               HOLO
//               <br />
//               GRAM
//             </span>
//           </div> */}
//           </div>
//         </div>
//       </div>
//     );
//   },
// );

// export default PanCardPdf;

import { QRCodeCanvas } from "qrcode.react";
import React from "react";
import { FaCaretLeft } from "react-icons/fa6";
import { useAssets } from "../Context/AssetsContext";

const PanCardPdf = React.forwardRef(
  ({ panData, uploadedImageUrl, uploadedSignatureUrl, qrText }, ref) => {
    const { assets } = useAssets();
    const formatDate = (dateString) => {
      if (!dateString) return "N/A";
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    };

    // ✅ SIGNATURE BOX COMPONENT - Reusable for both preview and PDF
    const SignatureBox = () => {
      return (
        <div
          className={`flex items-center justify-center rounded-sm  overflow-hidden ${
            uploadedSignatureUrl ? "bg-transparent" : "border-gray-300 bg-white"
          }`}
          style={{
            minWidth: "7rem",
            minHeight: "0.2rem",
            maxWidth: "16rem",
            maxHeight: "1.7rem",
            aspectRatio: "5/2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.25rem",
            boxSizing: "border-box",
          }}
        >
          {uploadedSignatureUrl ? (
            <img
              src={uploadedSignatureUrl}
              alt="Signature"
              className="object-contain"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                width: "auto",
                height: "auto",
                display: "block",
              }}
            />
          ) : (
            <div
              style={{
                color: "#9CA3AF",
                fontSize: "12px",
                textAlign: "center",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            ></div>
          )}
        </div>
      );
    };

    return (
      <div
        className="flex justify-center items-start mx-[19rem] min-h-screen bg-white py-8 gap-x-6"
        ref={ref}
      >
        {/* Left side - Front of PAN Card */}
        <div className="w-[210mm] flex justify-center">
          <div
            className="w-[24.8rem] h-[15.8rem] rounded-xl p-3 relative box-border bg-cover bg-center"
            style={{ backgroundImage: `url(${assets.panFront})` }}
          >
            {/* PAN Details Row */}
            <div className="flex gap-1 mt-12">
              {/* Photo */}
              <div className="w-[70px] h-[60px] border">
                <img
                  src={uploadedImageUrl}
                  alt="User"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* PAN Info */}
              <div className="flex-1 text-center">
                <p className="text-[10px] font-bold tracking-tight text-blue-900">
                  स्थायी लेखा संख्या कार्ड
                </p>
                <p className="text-[10px] font-bold tracking-tight text-blue-900">
                  Permanent Account Number Card
                </p>
                <p className=" text-sm font-bold tracking-widest text-black">
                  {panData.pan_number}
                </p>
              </div>

              {/* QR Code */}
              <div className="bg-white p-[0.17rem]">
                <QRCodeCanvas value={qrText} level="H" size={80} />
              </div>
            </div>

            {/* Footer Details */}
            <div className="text-[9.5px] absolute left-3 right-3 bottom-3">
              <p className="flex flex-col mb-3 ">
                <strong className="text-blue-900">नाम/ Name:</strong>
                <strong>{panData.full_name}</strong>
              </p>

              <p className="flex flex-col mb-1">
                <strong className="text-blue-900 ">
                  पिता का नाम / Father's Name:
                </strong>
                <strong>{panData.father_name}</strong>
              </p>

              <div className="flex justify-between items-end mt-1">
                <p className="flex flex-col">
                  <strong className="text-blue-900">
                    जन्म की तारीख / <span className="flex">Date of Birth:</span>
                  </strong>
                  <strong>{formatDate(panData.dob)} </strong>
                </p>

                {/* ✅ SIGNATURE BOX - PDF */}
                <div className="ml-10">
                  <SignatureBox />
                </div>

                <div className="flex flex-col mb-2 text-[4px] text-black">
                  <div className="flex items-center">
                    <FaCaretLeft className="text-black absolute mt-2 ml-[0.29rem] text-[5px]" />
                    <p className="ml-3">
                      PAN Application Digitally Signed Card Not
                    </p>
                  </div>
                  <p className="ml-[0.8rem]">Valid unless Physically Signed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Back of PAN Card */}
        <div className="w-[210mm] flex justify-center">
          <div
            className="w-[24.8rem] h-[15.8rem] rounded-xl p-3 relative box-border bg-cover bg-center"
            style={{ backgroundImage: `url(${assets.panBack})` }}
          >
            {/* Back Side Content */}
            <div className="text-[8.5px] text-black leading-snug">
              {/* Hindi instruction */}
              <div className="mt-2">
                <p className="font-semibold">
                  इस कार्ड के खोने / पाने पर कृपया सूचित करें / लौटायें :
                </p>
                <p className="mt-1">
                  आयकर पैन सेवा इकाई, प्रोटिअन ईगॉव टेक्नोलॉजीज लिमिटेड <br />
                  पहली मंजिल, टाइम्स टॉवर, कमला मिल्स कंपाउंड, <br />
                  सेनापति बापट मार्ग, लोअर परेल, <br />
                  मुंबई ४०० ०१३
                </p>
              </div>

              {/* English instruction */}
              <div className="mt-12">
                <p className="mt-3 font-semibold">
                  If this card is lost / someone's lost card is found, <br />
                  please inform / return to :
                </p>
                <p className="mt-1">
                  Income Tax PAN Services Unit, Protean eGov Technologies
                  Limited <br />1<sup>st</sup> Floor, Times Tower, Kamala Mills
                  Compound, <br />
                  Senapati Bapat Marg, Lower Parel, <br />
                  Mumbai 400 013
                </p>

                {/* Contact Info */}
                <p className="">
                  Tel: 91-20-2721 8080, e-mail: tininfo@proteanctech.in <br />
                  ito.systems1@incometax.gov.in, pan@incometax.gov.in
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default PanCardPdf;
